export default "__VITE_ASSET__DqShJxok__"